// extracted by mini-css-extract-plugin
export var box = "Switcher-module--box--8d358";
export var box_md = "Switcher-module--box_md--bda64";
export var box_xmd = "Switcher-module--box_xmd--5b8ea";
export var box_flex = "Switcher-module--box_flex--b9691";
export var box_lg = "Switcher-module--box_lg--b4c73";
export var box_sm = "Switcher-module--box_sm--dee1b";
export var box_outer = "Switcher-module--box_outer--42be7";
export var box_whiteBg = "Switcher-module--box_white-bg--6eda1";
export var box_noMarginBottom = "Switcher-module--box_no-margin-bottom--83fb5";
export var box_noPadding = "Switcher-module--box_no-padding--30ccb";
export var box_outerGray = "Switcher-module--box_outer-gray--b5eba";
export var box_dark = "Switcher-module--box_dark--1bf16";
export var box_zIndex = "Switcher-module--box_z-index--e0eee";
export var box_zIndex6 = "Switcher-module--box_z-index-6--d913b";
export var box_eventsWithLine = "Switcher-module--box_events-with-line--47497";
export var box_featuresAo = "Switcher-module--box_features-ao--2ff68";
export var box_verticalPaddings = "Switcher-module--box_vertical-paddings--c5ab2";
export var clearP = "Switcher-module--clearP--a72b7";
export var clearP_vc = "Switcher-module--clearP_vc--f0a9c";
export var container = "Switcher-module--container--0c8ca";
export var switcher = "Switcher-module--switcher--763cf";
export var label = "Switcher-module--label--f02fc";
export var input = "Switcher-module--input--afb04";
export var fadeInAnimation = "Switcher-module--fadeInAnimation--3c4aa";
export var placeHolderShimmer = "Switcher-module--placeHolderShimmer--de89b";